import { converterNumeroBR } from './textoBR'

// Texto digitado num campo de dinheiro -> o mesmo valor escrito como o Brasil
// escreve. NAO poe "R$": o cifrao mora fixo na lateral do campo (CampoMoeda),
// para nao virar caractere que a pessoa apaga sem querer.
//
// ⚠ POR QUE ISTO EXISTE, medido em 16/08/2026 com locale pt-BR:
//
//   digitou "42,50"     -> <input type="number"> devolve "42.50"    ok
//   digitou "1.234,56"  -> <input type="number"> devolve "1.23456"  🔴
//   digitou "1234,56"   -> <input type="number"> devolve "1234.56"  ok
//
// O campo numerico do navegador ENGOLE o ponto de milhar. Quem digita
// "1.234,56" grava 1,23456 -- mil vezes menos, sem erro e sem aviso nenhum na
// tela. Nao e so incomodo de digitacao: e valor errado gravado, e o
// representante nao tem como perceber. Achado dela no smoke do beta.
//
// Texto que nao da para entender volta INTACTO: apagar o que a pessoa escreveu
// para "consertar" seria pior que deixar errado -- ela perde o que digitou e
// nao sabe por que.
export function formatarDigitacaoMoeda(texto: string): string {
  if (texto.trim() === '') return ''
  const valor = converterNumeroBR(texto)
  if (valor === null) return texto
  return valor.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
